import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Shop } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ShopModule extends VuexModule {
    @Action
    [Shop.findPageShop](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/findPage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.saveShop](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/save`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.deleteShopRecord](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.showShop]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/shop/show`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.findShopInfo]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/shop/findShopInfo`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.updateShopDescription](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/updateShopDescription`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.syncShop](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/findPage`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
    @Action
    [Shop.downloadShopRankingReport](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/shop/downloadRankingReport`,values, {responseType: 'blob'})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}